import BigNumber from '@/features/ui/typography/components/BigNumber'
import Button from '@/features/ui/typography/components/Button'
import Chip from '@/features/ui/typography/components/Chip'
import Description from '@/features/ui/typography/components/Description'
import Heading from '@/features/ui/typography/components/Heading'
import Label from '@/features/ui/typography/components/Label'
import Menu from '@/features/ui/typography/components/Menu'

export default {
    Menu,
    Label,
    Heading,
    Description,
    Chip,
    Button,
    BigNumber,
}
